<template>
  <submit-button 
    :working="working"
    @submit="submit" 
    left-icon="check-circle" type="far">
    Save
  </submit-button>
</template>
<script>
export default {
  
  props: {
    working: {
      type: Boolean
    }
  },

  methods: {
    submit() {
      this.$emit('save')
    }
  }

}
</script>